import axios from 'axios';
import { apiUrl } from './apiUrl';

export const get = receipt =>
    axios.get(`${apiUrl}/payment/receipt/${receipt}`)


// WEBPACK FOOTER //
// ./src/services/smartparking-api/Receipt.js